import { SplitHeader } from "./SitePrimitives";

export function SiteServices({
  badge,
  title,
  description,
  items,
  featuresTitle,
  features,
}: {
  badge: string;
  title: string;
  description: string;
  items: Array<{ name: string; description: string; image?: string }>;
  featuresTitle: string;
  features: Array<{ title: string; description: string; icon?: string }>;
}) {
  if (!title && !items.length) return null;
  return (
    <section id="services" className="pt-[60px] min-[810px]:pt-[49px] min-[1200px]:pt-[120px]">
      <div className="site-container">
        <SplitHeader badge={badge} title={title} description={description} titleClassName="min-[1200px]:max-w-[600px]" />
        {items.length ? (
          <div className="mt-8 grid gap-8 min-[810px]:mt-12 min-[810px]:grid-cols-3 min-[810px]:gap-6 min-[1200px]:mt-[66px]">
            {items.map((item) => (
              <article key={item.name}>
                <div className="relative h-[274px] overflow-hidden rounded-xl bg-white/5 min-[1200px]:h-[320px]">
                  {item.image ? (
                    <img src={item.image} alt="" className="h-full w-full object-cover" loading="lazy" />
                  ) : null}
                  <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/3 bg-[linear-gradient(180deg,rgba(0,0,0,0)_0%,rgba(0,0,0,0.35)_100%)]" />
                  <h3 className="absolute bottom-4 left-4 right-4 text-[18px] font-extrabold leading-[1.2] text-white min-[810px]:text-[22px] min-[1200px]:text-[24px]">
                    {item.name}
                  </h3>
                </div>
                {item.description ? (
                  <p className="site-lead mt-[18px] px-2 min-[810px]:mt-[18px] min-[1200px]:mt-6 min-[1200px]:px-3">
                    {item.description}
                  </p>
                ) : null}
              </article>
            ))}
          </div>
        ) : null}
        {features.length ? (
          <div className="mt-[72px] min-[810px]:mt-[88px] min-[1200px]:mt-[104px]">
            {featuresTitle ? (
              <h3 className="site-h3 mx-auto max-w-[332px] text-center text-white">{featuresTitle}</h3>
            ) : null}
            <div className="site-divider-x mt-8 min-[810px]:max-[1199px]:hidden" />
            <div className="grid min-[810px]:mt-[38px] min-[810px]:grid-cols-2 min-[810px]:gap-x-[81px] min-[810px]:px-8 min-[1200px]:mt-0 min-[1200px]:grid-cols-4 min-[1200px]:px-0">
              {features.map((feature, index) => (
                <article
                  key={feature.title}
                  className="relative flex flex-col items-center gap-4 px-6 pb-8 pt-4 text-center min-[810px]:px-0 min-[810px]:pb-[39px] min-[810px]:pt-[26px] min-[1200px]:pb-[55px]"
                >
                  {index > 0 ? (
                    <span
                      className={`absolute left-[-41px] top-0 h-full w-px bg-[linear-gradient(180deg,#374043_0%,rgba(139,161,169,0)_100%)] ${
                        index % 2 === 1 ? "hidden min-[810px]:block" : "hidden min-[1200px]:block"
                      }`}
                    />
                  ) : null}
                  {index > 0 ? <span className="site-divider-x absolute inset-x-0 top-0 min-[810px]:hidden" /> : null}
                  {index >= 2 ? (
                    <span className="site-divider-x absolute inset-x-[-41px] top-0 hidden min-[810px]:block min-[1200px]:hidden" />
                  ) : null}
                  {feature.icon ? <img src={feature.icon} alt="" className="h-10 w-10" loading="lazy" /> : null}
                  <h4 className="font-['Inter'] text-[16px] font-bold leading-[1.3] tracking-[-0.01em] text-[#F2F2F2] min-[810px]:text-[18px] min-[1200px]:text-[20px]">
                    {feature.title}
                  </h4>
                  <p className="site-body text-[#9F9F9F]">{feature.description}</p>
                </article>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}
